module.exports = __webpack_public_path__ + "img/iconPhone.be7aabb9.svg";